import { render, staticRenderFns } from "./CardLivePlayer.vue?vue&type=template&id=dfd582ec&scoped=true"
import script from "./CardLivePlayer.js?vue&type=script&lang=js&external"
export * from "./CardLivePlayer.js?vue&type=script&lang=js&external"
import style0 from "./CardLivePlayer.vue?vue&type=style&index=0&id=dfd582ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd582ec",
  null
  
)

export default component.exports